import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { postHeartbeat } from '../../services/heartbeat/post';
export var useHearbeatService = function useHearbeatService(endpoint, onAuthenticationFailed, onBadRequest) {
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    nextCallTimestamp = _useState2[0],
    setNextCallTimestamp = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    sessionExpiryTimestamp = _useState4[0],
    setSessionExpiryTimestamp = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    callHeartbeatService = _useState6[0],
    setCallHeartbeatService = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    deactivated = _useState8[0],
    setDeactivated = _useState8[1];
  useEffect(function () {
    if (callHeartbeatService && endpoint && !deactivated) {
      var callAsync = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var response;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return postHeartbeat(endpoint, onAuthenticationFailed, onBadRequest);
              case 3:
                response = _context.sent;
                setCallHeartbeatService(false);
                if (response && response.nextCallTimestamp) {
                  setNextCallTimestamp(new Date(response.nextCallTimestamp));
                }
                if (response && response.sessionExpiryTime) {
                  setSessionExpiryTimestamp(new Date(response.sessionExpiryTime));
                }
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setDeactivated(true);
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 9]]);
        }));
        return function callAsync() {
          return _ref.apply(this, arguments);
        };
      }();
      callAsync();
    }
  }, [callHeartbeatService, endpoint, onAuthenticationFailed, onBadRequest, deactivated]);
  return {
    nextCallTimestamp: nextCallTimestamp,
    sessionExpiryTimestamp: sessionExpiryTimestamp,
    callHeartbeatService: callHeartbeatService,
    setCallHeartbeatService: setCallHeartbeatService,
    deactivated: deactivated
  };
};